import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-document-viewer',
  templateUrl: 'document-viewer.component.html',
  styleUrls: ['document-viewer.component.scss']
})
export class DocumentViewerComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    pdfDefaultOptions.assetsFolder = 'bleeding-edge';
  }

  ngOnInit(): void {
  }
}